/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable brace-style */
/* eslint-disable prefer-template */
/* eslint-disable newline-after-var */
/* eslint-disable no-var */
define('instrumentation/event-formatter', ['lib/underscore', 'PageContext'], function(_, pageContext) {
  var fuzzifyText = function(untrimmedText) {
    if (untrimmedText && untrimmedText.trim().length) {
      var text = untrimmedText.trim();
      return text[0] + '***' + text[text.length - 1] + '(length=' + text.length + ')';
    }
    return '<EMPTY>';
  };

  var trancateText = function(text, isReservePartialText) {
    if (_.isEmpty(text)) {
      return '';
    }

    var MAX_LENGTH_TO_RECORD = 100;

    if (text.length <= MAX_LENGTH_TO_RECORD) {
      return text;
    }

    return isReservePartialText ? text.substring(0, MAX_LENGTH_TO_RECORD) + ' ...' : '<CONTENT_TOO_LONG>';
  };

  var getControlDisplayText = function(element) {
    var EMPTY_STRING = '<EMPTY>';
    var displayText;
    if (element.nodeName.toLowerCase() === 'input') {
      switch (element.type) {
      case 'password':
        displayText = element.value ? '<PASSWORD>' : EMPTY_STRING;
        break;
      case 'text':
        displayText = fuzzifyText(element.value);
        break;
      case 'radio':
        displayText = element.checked;
        break;
      case 'checkbox':
        displayText = element.checked;
        break;
      case 'file':
        displayText = '<FILE>';
        break;
      default:
        displayText = element.value && element.value.trim() ? element.value.trim() : EMPTY_STRING;
      }
    } else if (element.nodeName.toLowerCase() === 'select') {
      var options = element.options && element.options.length ? element.options.length + ' options: [' + _.map(element.options, function(option) { return option.value + '/' + option.text; }).join(',') + ']' : '';
      displayText = (element.selectedOptions && element.selectedOptions[0] ? element.selectedOptions[0].value + '/' + element.selectedOptions[0].text : '') + ' | ' + options;
      displayText = trancateText(displayText, true);
    } else if (element.nodeName.toLowerCase() === 'textarea') {
      displayText = fuzzifyText(element.value || element.innerHTML);
    } else if (element === document || element.parentNode === document.documentElement || element.parentNode === document.body) {
      displayText = element.nodeName;
    } else if (element.textContent && element.textContent.trim()) {
      displayText = '(textContent)' + trancateText(element.textContent.trim());
    } else if (element.innerHTML && element.innerHTML.trim()) {
      displayText = '(innerHTML)' + trancateText(element.innerHTML.trim());
    } else {
      displayText = EMPTY_STRING;
    }
    return displayText;
  };

  var getControlTypeFriendlyName = function(element) {
    var nodeName;
    if (element.nodeName.toLowerCase() === 'a') {
      nodeName = 'link';
    } else if (element.nodeName.toLowerCase() === 'input') {
      nodeName = 'input(' + element.type + ')';
    } else {
      nodeName = element.nodeName.toLowerCase();
    }
    return nodeName;
  };

  var buildEventLocationInfo = function(event) {
    return {
      x: event.x,
      y: event.y,
      screenX: event.screenX,
      screenY: event.screenY,
      clientX: event.clientX,
      clientY: event.clientY,
      pageX: event.pageX,
      pageY: event.pageY,
      offsetX: event.offsetX,
      offsetY: event.offsetY,
      scrollX: window.scrollX,
      scrollY: window.scrollY,
    };
  };

  var buildXPathInfo = function(element) {
    if (element.id !== '') {
      return 'id("' + element.id + '")';
    }

    if (element === document.body) {
      return element.tagName;
    }

    var ix = 0;
    try {
      var siblings = element.parentNode.childNodes;
      for (var i = 0; i < siblings.length; i++) {
        var sibling = siblings[i];
        if (sibling === element)                {
          return buildXPathInfo(element.parentNode) + '/' + element.tagName + '[' + (ix + 1) + ']';
        }
        if (sibling.nodeType === 1 && sibling.tagName === element.tagName)                {
          ix++;
        }
      }
    } catch (e) {
      return 'Get XPath Error';
    }
    return '';
  };

  var getComposedPath = function(event) {
    if (event.composedPath) {
      return event.composedPath();
    }

    // For IE and Edge compatibility
    if (event.path) {
      return event.path;
    }

    var target = event.target;
    var path = [];
    while (target.parentNode !== null) {
      path.push(target);
      target = target.parentNode;
    }
    path.push(document);
    path.push(window);
    return path;
  };

  var buildTargetPaths = function(paths) {
    var targetPathsInfo = [];

    _.each(paths, function(targetElement) {
      targetPathsInfo.push({
        className: targetElement.className,
        id: targetElement.id,
        nodeName: targetElement.nodeName,
      });
    });

    return targetPathsInfo;
  };

  var findRecognitionElement = function(element) {
    var node = element;
    var searchDepth = 5;
    while (searchDepth-- > 0) {
      if (node.id || node.className || node === document.body || node === document.documentElement) {
        return node;
      }
      node = node.parentNode;
    }
    return element;
  };

  var buildElementDesc = function(element) {
    var nodeName = getControlTypeFriendlyName(element);
    var displayText = getControlDisplayText(element);
    var elementWithIdOrName = findRecognitionElement(element);
    var parentNodeType = element === elementWithIdOrName ? null : 'ParentNode:' + getControlTypeFriendlyName(elementWithIdOrName);
    var id = elementWithIdOrName.id ? '#' + elementWithIdOrName.id : '';
    var className = elementWithIdOrName.className;

    return _.compact([nodeName, displayText, parentNodeType, id, className]).join(' | ');
  };

  var findContainer = function(element) {
    if (!element || element === document) { return null; }

    if (_.contains(['form'], element.nodeName.toLowerCase())) { return element; }

    return findContainer(element.parentNode);
  };

  var buildContainerDesc = function(element) {
    var container = findContainer(element);
    return container ? [container.nodeName, '#' + container.id, container.className].join(' | ') : '';
  };

  var clickEventFormatter = function(rawLog) {
    var event = rawLog.event;

    return {
      PageRoute: rawLog.pageRoute,
      EventInfo: JSON.stringify(buildEventLocationInfo(event)),
      Element: 'clicked: ' + buildElementDesc(event.target),
      ElementType: getControlTypeFriendlyName(event.target),
      ElementText: getControlDisplayText(event.target),
      ElementId: event.target.id || '',
      ElementClassName: event.target.className || '',
      Container: buildContainerDesc(event.target),
      TargetPathsInfo: JSON.stringify(buildTargetPaths(getComposedPath(event))),
      Xpath: buildXPathInfo(event.target),
      DevicePixelRatio: window.devicePixelRatio,
    };
  };

  var inputChangeEventFormatter = function (rawLog) {
    var event = rawLog.event;

    return {
      PageRoute: rawLog.pageRoute,
      EventInfo: JSON.stringify(buildEventLocationInfo(event)),
      Element: 'value changed: ' + buildElementDesc(event.target),
      ElementType: getControlTypeFriendlyName(event.target),
      ElementText: getControlDisplayText(event.target),
      ElementId: event.target.id || '',
      ElementClassName: event.target.className || '',
      Container: buildContainerDesc(event.target),
      TargetPathsInfo: JSON.stringify(buildTargetPaths(getComposedPath(event))),
      Xpath: buildXPathInfo(event.target),
      DevicePixelRatio: window.devicePixelRatio,
    };
  };

  var KEYS_TO_CAPTURE = [
    { keyCode: 13, keyName: 'Enter' },
    { keyCode: 9, keyName: 'Tab' },
  ];

  var keyboardEventFormatter = function (rawLog) {
    var event = rawLog.event;

    var keyInfo = {
      key: event.key,
      code: event.code,
      ctrlKey: event.ctrlKey,
      shiftKey: event.shiftKey,
      altKey: event.altKey,
      metaKey: event.metaKey,
      charCode: event.charCode,
      keyCode: event.keyCode,
    };

    var keyCode = event.keyCode || event.which;
    var matchedKey = _.find(KEYS_TO_CAPTURE, function(KEY) { return KEY.keyCode === keyCode; });
    var keyName = matchedKey ? matchedKey.keyName : '';

    var emptyOrExcute = function(element, builder) {
      return element ? builder(element) : '';
    };

    return {
      PageRoute: rawLog.pageRoute,
      Element: rawLog.keyEventType + ' on ' + keyName + ' :' + emptyOrExcute(event.target, buildElementDesc),
      ElementType: emptyOrExcute(event.target, getControlTypeFriendlyName),
      ElementText: emptyOrExcute(event.target, getControlDisplayText),
      ElementId: event.target && event.target.id ? event.target.id : '',
      ElementClassName: event.target && event.target.className ? event.target.className : '',
      Container: emptyOrExcute(event.target, buildContainerDesc),
      TargetPathsInfo: JSON.stringify(buildTargetPaths(getComposedPath(event))),
      Xpath: emptyOrExcute(event.target, buildXPathInfo),
      KeyCode: keyCode,
      KeyName: keyName,
      KeyEventType: rawLog.keyEventType,
      KeyInfo: JSON.stringify(keyInfo),
      DevicePixelRatio: window.devicePixelRatio,
    };
  };

  var routeChangeEventFormatter = function (rawLog) {
    var message;
    if (rawLog.isFullPageRefresh) {
      message = rawLog.isUnload ? 'Full page unloaded' : 'Full page rendered';
    } else if (rawLog.isEnter) {
      message = 'Page started';
    } else if (rawLog.isNavigation) {
      message = rawLog.isRecorded ? 'Page navigation - first time ' : 'Page navigation - reenter';
    } else {
      message = rawLog.isUnload ? 'Page ended (full page unloaded)' : 'Page ended (routing to ' + rawLog.nextRoute + ')';
    }

    return {
      IsFullPageRefresh: rawLog.isFullPageRefresh,
      PageRoute: rawLog.pageRoute,
      ViewName: rawLog.viewName,
      PreviousRoute: rawLog.previousRoute,
      PreviousView: rawLog.previousView,
      IsEnter: rawLog.isEnter,
      IsUnload: rawLog.isUnload,
      NextRoute: rawLog.nextRoute,
      Message: message,
      Referrer: rawLog.isFullPageRefresh ? document.referrer : null,
      FeaturePilotFlag: rawLog.isFullPageRefresh ? JSON.stringify(pageContext.FeaturePilotFlag) : null,
    };
  };

  return {
    KEYS_TO_CAPTURE: KEYS_TO_CAPTURE,
    clickEventLogFormatter: clickEventFormatter,
    inputChangeEventLogFormatter: inputChangeEventFormatter,
    keyboardEventLogFormatter: keyboardEventFormatter,
    routeChangeEventLogFormatter: routeChangeEventFormatter,
  };
});
